import { _MaskMaintainBase } from './maskMaintainBase'

export class _MaskMaintainSmall extends _MaskMaintainBase {
  cssType: 'default' | 'small' = 'small'
  protected initPC(): this {
    this['--mask-maintain-border-radius'] = '0'
    this['--maintain-circle-width'] = '0.50rem'
    this['--maintain-circle-height'] = '0.50rem'
    this['--maintain-text-margin-top'] = '0.06rem'
    this['--maintain-text-font-size'] = '0.16rem'
    return this
  }
  protected initH5(): this {
    this['--mask-maintain-border-radius'] = '0'
    this['--maintain-circle-width'] = '0.50rem'
    this['--maintain-circle-height'] = '0.50rem'
    this['--maintain-text-margin-top'] = '0.10rem'
    this['--maintain-text-font-size'] = '0.18rem'
    return this
  }
}
